<template>
  <v-dialog
    v-model="dialog"
    max-width="800"
    persistent
    scrollable
  >
    <template #activator="{ on, attrs }">
      <v-btn
        v-bind="attrs"
        :title="$tc('common.follower', 2)"
        small
        v-on="on"
        @click="getData"
      >
        <v-icon>mdi-account-plus-outline</v-icon>
        <v-icon>mdi-account-remove-outline</v-icon>
      </v-btn>
    </template>

    <v-card>
      <v-toolbar flat>
        <v-toolbar-title>
          {{ $tc('common.follower', 2) }}
        </v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <Loading :loading="!loaded" />
        <v-container
          v-if="loaded && model"
          fluid
        >
          <v-row>
            <v-col>
              <h2>{{ $tc('common.person', 2) }}</h2>
              <vMultiselectListbox 
                v-model="selectedPersons"
                :options="model.metadata.persons"
                :reduce-display-property="(option) => option.text"
                :reduce-value-property="(option) => option.value"
                :search-options-placeholder="$t('deliveryFollowersDialog.persons.searchOptions')"
                :selected-options-placeholder="$t('deliveryFollowersDialog.persons.searchSelected')"
                :no-options-text="$t('deliveryFollowersDialog.persons.noOption')"
                :selected-no-options-text="$t('deliveryFollowersDialog.persons.noSelected')"
                :no-options-found-text="$t('deliveryFollowersDialog.persons.noOptionFound')"
                :no-selected-options-found-text="$t('deliveryFollowersDialog.persons.noSelectedFound')"
                @change="hasChanged = true"
              />
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>

      <v-divider />

      <v-card-actions v-if="loaded">
        <v-spacer />
        <v-btn
          outlined
          color="primary"
          @click="cancel"
        >
          {{ $t('common.cancel') }}
        </v-btn>
        <v-btn
          color="secondary"
          :loading="saving"
          :disabled="!hasChanged"
          @click="save"
        >
          {{ $t('common.save') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Loading from '@/components/Loading';

export default {
  name: 'DeliveryResponsibleDialog',
  components: {
    Loading
  },
  data() {
    return {
      model: null,
      dialog: false,
      loaded: false,
      saving: false,
      hasChanged: false,
      selectedPersons: []
    };
  },
  methods: {
    async getData() {
      const url = `delivery/changefollowers/${this.$route.params.id}`;

      try {
        const response = await this.$api.get(url);

        this.model = response.data;
        this.selectedPersons = this.model.metadata.persons.filter(el => this.model.data.followerPersonIds.includes(el.value));
        this.loaded = true;
      } catch (error) {
        console.error(error);
      }
    },
    cancel() {
      this.dialog = false;
    },
    async save() {
      this.saving = true;

      const data = {
        followerPersonIds: this.selectedPersons.map(el => el.value)
      }

      try {
        await this.$api.put(`delivery/changefollowers/${this.$route.params.id}`, data);
      } catch (error) {
        console.error(error);
      } finally {
        this.$emit('update:followers');
        this.saving = false;
        this.dialog = false;
      }
    }
  }
};
</script>